import React, { ReactNode } from 'react';
import clsx from 'clsx';

const SideDescription = ({
  text,
  children,
  className,
}: {
  text?: string;
  children?: ReactNode;
  className?: string;
}) => {
  const mainStyle = 'text-center text-gray-medium mt-4';
  // If text is provided, render simple text description
  if (text) {
    return <p className={clsx(mainStyle, className)}>{text}</p>;
  }

  // If children are provided, render complex content
  return (
    <p
      className={clsx(
        'flex gap-2 justify-center items-center',
        mainStyle,
        className
      )}
    >
      {children}
    </p>
  );
};

export default SideDescription;
